module.exports = __webpack_public_path__ + "img/map-pin.d2fc6fd6.svg";